import React, { useCallback, useEffect, useMemo, useReducer } from 'react'
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap'
import { PersonalFirmaAvisoEntrada } from './TypesFirmaAvisoEntrada'
import { reducer } from './ReducerFirmaAvisoEntrada';
import { ScrollToTop } from 'layouts/functionsLayout';
import { HandleSubirDocumentoAvisoEntrada, ObtenerPersonalFirmaDocumentoPazSalvo, RechazarAvisoEntradaServidor } from './FunctionsFirmaAvisoEntrada';
import { alertService } from 'components/Varios/alert_service';
import { ObjetoSubirDocumento } from 'components/Varios/Modals/ModalSubirDocumentoFirmado';
import TablaFirmaPersonalAvisoSalida from './TablaFirmaPersonalAvisoEntrada';
import { authenticationService } from 'services/authentication.service';
import ModalMensaje from 'components/Varios/Modals/ModalMensaje';
import Cargando from 'components/Varios/Cargando';

export type FirmaAvisoEntradaState = {
    loadingInfo: boolean,
    listadoPersonal: PersonalFirmaAvisoEntrada[],
    sendingEmail: boolean
}

export type FirmaAvisoEntradaAction =
    | { type: "OBTENER_INFORMACION" }
    | { type: "INFORMACION_CARGADA", payload: PersonalFirmaAvisoEntrada[] | undefined }
    | { type: "NOTIFICANDO" }
    | { type: "NOTIFICADO" }

export default function FirmaAvisoEntradaFinanciero() {

    const initialState: FirmaAvisoEntradaState = {
        listadoPersonal: [],
        loadingInfo: false,
        sendingEmail: false
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    async function ObtenerInformacionPersonalAvisoEntrada() {
        ScrollToTop();
        dispatch({ type: "OBTENER_INFORMACION" });
        const respuesta = await ObtenerPersonalFirmaDocumentoPazSalvo();
        if (respuesta.status !== 200) {
            alertService.error(respuesta.errorMessage);
        }
        dispatch({ type: "INFORMACION_CARGADA", payload: respuesta.dataResponse })
    }

    useEffect(() => {
        ObtenerInformacionPersonalAvisoEntrada();
    }, [])

    async function SubirDocumento(objeto: ObjetoSubirDocumento) {
        const status = await HandleSubirDocumentoAvisoEntrada(objeto);
        if (status === 1) {
            await ObtenerInformacionPersonalAvisoEntrada();
        }

    }

    const NegarAvisoEntrada = useCallback(
        async (idOtrosDocumentos: number, observacion: string) => {
            dispatch({ type: "NOTIFICANDO" })
            const respuesta = await RechazarAvisoEntradaServidor(idOtrosDocumentos, observacion);
            if (respuesta.status === 200) {
                alertService.success("El aviso de entrada del servidor ha sido negado y notificado.")
                await ObtenerInformacionPersonalAvisoEntrada();
            } else {
                alertService.error(respuesta.errorMessage ?? "Ha ocurrido un inconveniente");
            }
            dispatch({ type: "NOTIFICADO" })

            return respuesta.status === 200 ? 1 : 0;
        },
        [state.listadoPersonal]
    )

    const TablaPersonalFirmar = useMemo(() => {
        return (
            <TablaFirmaPersonalAvisoSalida
                loading={state.loadingInfo}
                informacion={state.listadoPersonal}
                onClickSubirDocumentoFirmado={async (objeto) => await SubirDocumento(objeto)}
                onClickRechazarDocumentoServidor={async (idOtrosDocumentos, observacion) => NegarAvisoEntrada(idOtrosDocumentos, observacion)}
            />
        )

    }, [state])

    return (
        <div className="content">
            <>
                <Row>
                    <Col>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className='title'> Firma documento Aviso de Entrada </h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                {TablaPersonalFirmar}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>

            <ModalMensaje
                tituloModal='Notificando'
                show={state.sendingEmail}
                centered={true}
                mensaje=''
                mensajeHtml={<div> <Cargando /></div>}
                onClose={() => dispatch({ type: "NOTIFICADO" })}
                size='md'
            />
        </div>
    )
}